import { Field, Formik } from "formik";
import Action from "pages/_components/Action";
import Button from "pages/_components/Button";
// import Dropdown from "pages/_components/Dropdown";
import TextField from "pages/_components/fields/TextField";
import GridTable from "pages/_components/GridTable/GridTable";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import ProductList from "pages/_components/product/List";
import { bool } from "prop-types";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { actions as agendaActions } from "reducers/contactDestination";
import { ReactComponent as Show } from "styles/images/search.svg";
import * as i18n from "util/i18n";
import { isIOS } from "react-device-detect";
import CustomData from "pages/_components/CustomData/CustomData";
import { useListContacts } from "./hooks/useListContacts";
import ContactItem from "./_components/ContactItem";

const ContactDestinationPage = ({ isDesktop }) => {
    const { listFrequentDestinations, moreDestinations, fetching, dispatch, pageNumber, totalPages } = useListContacts({
        loadDetail: false,
    });
    const [filter, setFilter] = useState("");
    // const isFetchingExport = false;

    const handleDownload = (format) => {
        dispatch(agendaActions.downloadDestinations(filter, format, pageNumber, totalPages));
    };

    const handleSearch = (values) => {
        setFilter(values.filter);
        dispatch(agendaActions.loadListRequest(values.filter));
    };
    const fetchMoreTransactions = () => {
        dispatch(agendaActions.loadListRequest("", pageNumber + 1));
    };
    useEffect(() => {
        dispatch(agendaActions.cleanFrecuentDestination());
    }, []);

    const revealFunction = (values) => (
        <Button className="btn-only-icon" bsStyle="link" block={false} onClick={() => handleSearch(values)}>
            <Show className="svg-image" />
        </Button>
    );

    return (
        <>
            <Notification scopeToShow="FrequentDestinations" />
            <ResponsiveHeader id="transfer.frequentDestination.title" backLinkTo="/desktop">
                <DesktopButtons>
                    <div className="toolbar-item  add-button" key="addMoreButtonsRight">
                        <Button
                            className="btn-outline"
                            onClick={() => handleDownload("pdf")}
                            image="images/figma/icon/download.svg"
                            label="global.download"
                        />
                    </div>
                    {/* <Dropdown
                        image="images/download.svg"
                        label="global.download"
                        buttonClass="btn btn-outline"
                        fetching={fetching}
                        pullRight>
                        <Button
                            onClick={() => handleDownload("pdf")}
                            label="global.download.pdf"
                            className="dropdown__item-btn"
                            bsStyle="link"
                        />
                         <Button
                            onClick={() => handleDownload("xls")}
                            label="global.download.xls"
                            className="dropdown__item-btn"
                            bsStyle="link"
                        />
                    </Dropdown> */}
                    <Link className="btn btn-primary btn-block add-contact" to="/contactDestination/add">
                        <Image src="images/figma/icon/nuevo.svg" className="icon-medium svg-icon" />{" "}
                        <I18n id="transfer.frequentDestination.new" />
                    </Link>
                </DesktopButtons>
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="transfer.frequentDestination.new" to="/contactDestination/add" />
                    <Action labelKey="global.download" handleClick={() => handleDownload("pdf")} />
                    {/* <Action labelKey="global.download.xls" handleClick={() => handleDownload("xls")} /> */}
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer showLoader={fetching}>
                <Formik initialValues={{ filter }}>
                    {({ values }) => (
                        <Form>
                            <Field
                                component={TextField}
                                name="filter"
                                type="text"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleSearch(values);
                                    }
                                }}
                                inputFunctions={revealFunction(values)}
                                placeholderText={i18n.get("echecks.search.contact")}
                                hideLabel
                                variant="outlined"
                            />
                        </Form>
                    )}
                </Formik>
                {listFrequentDestinations.length > 0 ? (
                    <ProductList
                        fetchingWithPreviousData
                        fetching={fetching}
                        items={listFrequentDestinations || []}
                        noDataText="agenda.no.results"
                        noFiltersDataText="agenda.no.results"
                        renderItem={(item) => (
                            <GridTable.Container
                                columns={isDesktop ? 4 : 1}
                                rows={isDesktop ? 2 : 1}
                                key={`contact-item-${item.idFrequentDestination}`}
                                renderAs={Link}
                                to={`/contactDestination/${item.idFrequentDestination}`}>
                                <ContactItem contact={item} isDesktop={isDesktop} />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="contacts-list text-neutral">
                                {listItem}
                                {moreDestinations && (
                                    <Button
                                        bsStyle="link"
                                        onClick={() => fetchMoreTransactions()}
                                        image="images/figma/icon/arrow.svg"
                                        label="global.showMore"
                                    />
                                )}
                            </GridTable>
                        )}
                    </ProductList>
                ) : (
                    <div className="box info">
                        <CustomData
                            icon="information_fill.svg"
                            titleText="contactDestination.service.noData"
                            titleTextType="I18N"
                        />
                    </div>
                )}
            </MainContainer>
        </>
    );
};

ContactDestinationPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ContactDestinationPage;
